export const PROCESSED_DOCUMENTS_FETCH_ERROR =
  'PROCESSED_DOCUMENTS_FETCH_ERROR';
export const PROCESSED_DOCUMENTS_FETCHING = 'PROCESSED_DOCUMENTS_FETCHING';
export const GET_PROCESSED_DOCUMENTS = 'GET_PROCESSED_DOCUMENTS';
export const PROCESSED_DOCUMENTS_GET_DATA = 'PROCESSED_DOCUMENTS_GET_DATA';



// WEBPACK FOOTER //
// ./src/pages/processeddocuments/state/page/types.js